export const normalizeCNPJ = (value: string): string =>
  String(value ?? '')
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, '');
